export {
    EmbeddedMessageWrapper,
    EmbeddedMessageWrapperProps,
} from './components/EmbeddedMessageWrapper';
